<template>
  <EdroneNavigationBottom>
    <template #start>
      <EdroneButton type="text" :disabled="!!actor?.snapshot.value.hasTag('upgradingPlan')" @click="handleCancel">
        {{ translation.close }}
      </EdroneButton>
    </template>
    <template #end>
      <EdroneButton
        type="solid"
        :disabled="!!actor?.snapshot.value.hasTag('upgradingPlan')"
        :loading="!!actor?.snapshot.value.hasTag('upgradingPlan')"
        @click="handleConfirm"
      >
        {{ translation.submit }}
      </EdroneButton>
    </template>
  </EdroneNavigationBottom>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { storeToRefs } from "pinia";
import { useFreemiumStore } from "../Freemium.store";
import { symbolMachineFreemium } from "vue-app/components/Freemium/Freemium.machine.ts";
import { amplitudeSendEvent } from "vue-app/utils/amplitude.ts";
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneNavigationBottom from "edrone-components/EdroneNavigationBottom.vue";

const translation = window._trans._freemium.upgradeDrawer;

const actor = inject(symbolMachineFreemium);
const store = useFreemiumStore();
const { selectedCustomersOption } = storeToRefs(store);

function handleConfirm() {
  amplitudeSendEvent("Freemium_Upgrade_Submit_Clicked", {
    selected_option: selectedCustomersOption.value,
  });
  actor?.send({ type: "CONFIRM" });
}

function handleCancel() {
  amplitudeSendEvent("Freemium_Drawer_Closed");
  actor?.send({ type: "CANCEL" });
}
</script>
